// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"939f28097e5d1074","4973":"81f7617d3aea6b18","7244":"81f7617d3aea6b18","7479":"81f7617d3aea6b18","8759":"97949ed14a3093d1"}[chunkId] + ".css";
};